module.exports = __webpack_public_path__ + "img/upper_pocket_height.b7651cfd.png";